interface IBannerProps {
	label: string;
	children?: React.ReactNode;
	maxWidth?: string;
	backgroundColor?: string; // Accepts a Tailwind CSS color class
	buttonBorderColor?: string;
}

const Banner: React.FC<IBannerProps> = ({
	label,
	children,
	maxWidth = "w-full",
	backgroundColor = "bg-white", // Default to white
	buttonBorderColor = "border-orange-600", // Default to sky-950
}) => {
	return (
		<div
			className={`flex flex-col items-center justify-start ${maxWidth} m-6`}
		>
			<span
				className={`bg-gradient-to-r from-sky-900 to-sky-700 text-white 
				min-h-24 flex items-center justify-center uppercase drop-shadow-lg text-2xl text-center tracking-wider font-semibold border-b-8 w-full ${buttonBorderColor}`}
			>
				{label}
			</span>
			<div
				className={`${backgroundColor} p-8  drop-shadow-2xl w-full overflow-auto`}
			>
				{children}
			</div>
		</div>
	);
};

export default Banner;
